<template>
  <div
    class="flex cursor-pointer items-center space-x-2"
    @click="showInfoModal = true"
  >
    <template v-if="cart && userGift">
      <span class="text-teal-primary text-sm"
        ><span class="font-semibold"
          >{{ formattedTotal }}
          in cart
        </span>
        / {{ formattedBalance }} credit</span
      >
      <img src="@/assets/images/info.svg" class="h-6 w-6" />
      <ZnModal
        size="small"
        :show-close-icon="false"
        :show="showInfoModal"
        @close="showInfoModal = false"
      >
        <template #title>
          <h1 class="text-lg font-semibold">How credit works</h1>
        </template>
        <template #body>
          <ul class="mt-5 list-disc space-y-5 px-6">
            <li>
              Credit is automatically applied to your account and works like a
              gift card - feel free to apply it across multiple purchases.
            </li>
            <li>
              Credit can be applied to all products from our current catalog,
              including taxes and shipping.
            </li>
            <li>You're responsible for any costs over your credit amount.</li>
            <li>
              Credit must be used by
              <span class="font-semibold">{{ giftEndDate }}</span> and does not
              carry over or transfer.
            </li>
          </ul>
          <div class="mt-5 flex">
            <ZnButton
              class="w-full text-center"
              type="secondary"
              @click="showInfoModal = false"
              >Close</ZnButton
            >
          </div>
        </template>
      </ZnModal>
    </template>
  </div>
</template>

<script setup lang="ts">
import { format, parseISO } from 'date-fns'
import { formatCurrency } from '@/utils/helper/formatCurrency'
import { useUserStore } from '~/store/user'
import { useCart } from '~/composables/useCart'
import { ref, computed } from '#imports'

const { cart } = useCart()
const { userGift } = useUserStore()

const showInfoModal = ref<boolean>(false)

const formattedTotal = computed<string>(() =>
  formatCurrency(
    location.pathname === '/checkout/orderreview'
      ? cart.value?.prices?.grand_total?.value ?? 0
      : cart.value?.prices?.subtotal_excluding_tax?.value ?? 0,
    'en-US',
    {
      currency: 'USD',
      minimumFractionDigits: 2,
    },
  ),
)

const formattedBalance = computed<string>(() =>
  formatCurrency(userGift?.usage?.balance ?? 0, 'en-US', {
    currency: 'USD',
    minimumFractionDigits: 2,
  }),
)

const giftEndDate = computed<string>(() => {
  const { to } = userGift?.schedule?.date ?? {}
  if (to) {
    return format(parseISO(to), 'MM/dd/yyyy')
  }
  return '--'
})
</script>
